import confetti from 'canvas-confetti';


const CONFETTI_THRESHOLD = {
  TIER1: 5,
  TIER2: 25,
  TIER3: 50,
  TIER4: 100,
  TIER5: 250,
};

const PARTICLE_COUNT = {
  TIER1: 10,
  TIER2: 20,
  TIER3: 35,
  TIER4: 55,
  TIER5: 100,
};

const LIMIT = {
  angle: {
    min: 55,
    max: 125,
  },
  spread: {
    min: 240,
    max: 360,
  },
};

function randomInRange(min, max) {
  const range = max - min;
  const randomNum = Math.random() * range;

  return randomNum + min;
}

const triggerConfetti = (amount) => {
  let numParticles = 0;
  if (amount > 0 && amount < CONFETTI_THRESHOLD.TIER1) {
    numParticles = PARTICLE_COUNT.TIER1;
  } else if (amount < CONFETTI_THRESHOLD.TIER2) {
    numParticles = PARTICLE_COUNT.TIER2;
  } else if (amount < CONFETTI_THRESHOLD.TIER3) {
    numParticles = PARTICLE_COUNT.TIER3;
  } else if (amount < CONFETTI_THRESHOLD.TIER4) {
    numParticles = PARTICLE_COUNT.TIER4;
  } else if (amount < CONFETTI_THRESHOLD.TIER5) {
    numParticles = PARTICLE_COUNT.TIER5;
  }

  const config = {
    angle: randomInRange(LIMIT.angle.min, LIMIT.angle.max),
    spread: randomInRange(LIMIT.spread.min, LIMIT.spread.max),
    particleCount: numParticles,
    origin: { y: 0.6 },
  };

  confetti(config);
};

export { triggerConfetti };
